﻿import * as eventTypes from '../../../map/utils/eventTypes';
export default class ChartControl {
    constructor(rootUrl, chartsContainer, resourceHandler, layerSettingsHandler, classId) {
        this.rootUrl = rootUrl;
        this.chartsContainer = chartsContainer;
        this.resourceHandler = resourceHandler;
        this.layerSettingsHandler = layerSettingsHandler;
        this.classId = classId;
        this._init();
    }

    _init() {
        console.log("GG");
        this._addEventHandlers();
    }

    _addEventHandlers() {
        $event.register(eventTypes.FEATURES_CHANGED, this._getFeaturesChangedHandler(), this, this.classId);
    }

    _getFeaturesChangedHandler() {
        var handler = (eventName, data, sender) => {
            if (data != null) {
                let layersChanged = Object.keys(data);

                if (layersChanged.length > 0) {
                    debugger;
                }
            }
        };

        return handler;
    }
}